"use client";

import { AssignCertificate } from "components/ui/v2/certificates/bundle/Certificates/Forms/AsignCertificate";

export const ASSIGN_CERTIFICATE_EMAIL_FORM_ID = "assign-certificate-email-form";
export const ASSIGN_CERTIFICATE_TEAM_FORM_ID = "assign-certificate-team-form";

export interface AssignCertificateModalContentV2Props {
  certificate?: Parameters<typeof AssignCertificate>[0]["certificate"];
  onClose?: () => void;
  hideHeader?: boolean;
  hideFooter?: boolean;
  activeTab?: "email" | "team";
  onTabChange?: (tab: "email" | "team") => void;
  onLoadingChange?: (loading: boolean) => void;
  emailFormId?: string;
  teamFormId?: string;
}

export function AssignCertificateModalContentV2({
  certificate,
  onClose,
  hideHeader = true,
  hideFooter = false,
  activeTab,
  onTabChange,
  onLoadingChange,
  emailFormId = ASSIGN_CERTIFICATE_EMAIL_FORM_ID,
  teamFormId = ASSIGN_CERTIFICATE_TEAM_FORM_ID,
}: AssignCertificateModalContentV2Props) {
  return (
    <AssignCertificate
      certificate={certificate}
      onClose={onClose}
      hideHeader={hideHeader}
      hideFooter={hideFooter}
      activeTab={activeTab}
      onTabChange={onTabChange}
      onLoadingChange={onLoadingChange}
      emailFormId={emailFormId}
      teamFormId={teamFormId}
    />
  );
}
